import { useEffect } from "react";

import { useAppDispatch, useAppSelector } from "app/redux-store-interactions";
import { explorerActions, selectCurrentProjectVersion } from "slices/explorer";

import { useProjectLatestVersion } from "./useProjectLatestVersion";

export function useCheckNewProjectVersion() {
    const { data: latestVersion } = useProjectLatestVersion({ poll: true });

    const currentProjectVersion = useAppSelector(selectCurrentProjectVersion);
    const dispatch = useAppDispatch();

    const fetchedCurrentProjectVersionId = latestVersion?.id ?? null;

    useEffect(() => {
        if (fetchedCurrentProjectVersionId !== currentProjectVersion) {
            // Only set the current project when it's not set yet.
            // Current project version is the version of the project that the user is currently working on,
            // and we're not gonna get the new version until the user refreshes the page.
            if (!currentProjectVersion) {
                dispatch(explorerActions.setCurrentProjectVersion(fetchedCurrentProjectVersionId));
            }

            // First time currentProjectVersion will be null - that's not a change, it's the initial load
            // but if currentProjectVersion is not null, it means a new version is available
            if (currentProjectVersion) {
                dispatch(explorerActions.setNewProjectVersionStatus({ available: true, dismissed: false }));
            }
        }
    }, [dispatch, fetchedCurrentProjectVersionId, currentProjectVersion]);
}
